import wx from "weixin-sdk-js";
import {Toast} from 'vant';
import md5 from 'js-md5';
import base64 from 'base-64';
// 是否正式环境
// export const isProd = process.env.NODE_ENV === 'production';
export const isProd = window.isProdStatus;
// 请求连接前缀
export const baseUrl = window.requestBaseHref;
// export const baseUrl = '//jymall.9617777.com';


export const drawBaseUrl = isProd?'//g.9617777.com/market':'https://pre.market.9617777.com';
export const drawUrl = isProd?'//g.9617777.com/market':'https://pre.market.9617777.com';

//密码加密
export function encodePwd($pwd, $begin = 'jycard', $end = 'jycoin') {
  $pwd = md5($pwd);
  return base64.encode(`${$begin}${$pwd}${$end}`);
}

// 是否在支付宝客户端内
export function isAlipayClient() {
  return navigator.userAgent.indexOf('AlipayClient') > -1
}
//是否在支付宝小程序里
export function isAliMiniApp() {
  return new Promise((resolve) => {
    if (window.my) {
      window.my.getEnv((res) => {
        resolve(res.miniprogram || res.miniProgram)
      })
    } else {
      resolve()
    }
  })
}
//是否在微信客户端里
export function isWeChat() {
  return navigator.userAgent.indexOf('MicroMessenger') > -1;
}
//判断是否在微信小程序内
export function isWeChatMiniApp() {
  return new Promise((resolve) => {
    wx.miniProgram.getEnv((res) => {
      resolve(res.miniprogram || res.miniProgram)
    })
  })
}

//获取签名key
const signKey = 'ccbde23d6f0f8cae5326c8b8fd6544f2';

export function createSign(arg){
  let stringA = obj2str(arg);
  let stringSignTemp = stringA?stringA+`&key=${signKey}`:stringA+`key=${signKey}`;
  let sign = md5(stringSignTemp);
  return sign;
}

export function obj2str(arg) {
  var keys = Object.keys(arg)
  keys = keys.sort() //参数名ASCII码从小到大排序（字典序）；
  var newArgs = {}
  keys.forEach(function (key) {
    if (arg[key] !== "" && arg[key] != 'undefined') {  //如果参数的值为空不参与签名；
      newArgs[key] = arg[key]  //参数名区分大小写；
    }
  })
  var string = ''
  for (var k in newArgs) {
    string += '&' + k + '=' + newArgs[k]
  }
  string = string.substr(1)
  return string
}

export const regFenToYuan = (fen) =>{
  var num = fen;
  num=fen*0.01;
  num+='';
  var reg = num.indexOf('.') >-1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num=num.replace(reg,'$1');
  num = toDecimal2(num)
  return num
};

const toDecimal2 = (x) => {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}

//toast提示
export function showMsgToast(msg, func, time) {
	!time && (time = 2000);
	Toast({
    forbidClick: true,
		message: msg,
		onClose: function() {
			func && func();
		}
	})
}

/*
   * 判断obj是否为一个整数
   */
function isInteger(obj) {
  return Math.floor(obj) === obj
}
/*
* 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
* @param floatNum {number} 小数
* @return {object}
*   {times:100, num: 314}
*/
function toInteger(floatNum) {
  var ret = {times: 1, num: 0}
  if (isInteger(floatNum)) {
      ret.num = floatNum
      return ret
  }
  var strfi  = floatNum + ''
  var dotPos = strfi.indexOf('.')
  var len    = strfi.substr(dotPos+1).length
  var times  = Math.pow(10, len)
  var intNum = Number(floatNum.toString().replace('.',''))
  ret.times  = times
  ret.num    = intNum
  return ret
}
/*
* 核心方法，实现加减乘除运算，确保不丢失精度
* 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
*
* @param a {number} 运算数1
* @param b {number} 运算数2
* @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
* @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
*
*/
function operation(a, b, digits, op) {
  var o1 = toInteger(a)
  var o2 = toInteger(b)
  var n1 = o1.num
  var n2 = o2.num
  var t1 = o1.times
  var t2 = o2.times
  var max = t1 > t2 ? t1 : t2
  var result = null
  switch (op) {
      case 'add':
          if (t1 === t2) { // 两个小数位数相同
              result = n1 + n2
          } else if (t1 > t2) { // o1 小数位 大于 o2
              result = n1 + n2 * (t1 / t2)
          } else { // o1 小数位 小于 o2
              result = n1 * (t2 / t1) + n2
          }
          return (result / max).toFixed(digits)
      case 'subtract':
          if (t1 === t2) {
              result = n1 - n2
          } else if (t1 > t2) {
              result = n1 - n2 * (t1 / t2)
          } else {
              result = n1 * (t2 / t1) - n2
          }
          return (result / max).toFixed(digits)
      case 'multiply':
          result = (n1 * n2) / (t1 * t2)
          return result.toFixed(digits)
      case 'divide':
          result = (n1 / n2) * (t2 / t1)
          return result.toFixed(digits)
  }
}
// 加减乘除的四个接口
function add(a, b, digits = 2) {
  return operation(a, b, digits, 'add')
}
function subtract(a, b, digits = 2) {
  return operation(a, b, digits, 'subtract')
}
function multiply(a, b, digits = 2) {
  return operation(a, b, digits, 'multiply')
}
function divide(a, b, digits = 2) {
  return operation(a, b, digits, 'divide')
}
// exports
export const amountCalculation = {
  add: add,
  subtract: subtract,
  multiply: multiply,
  divide: divide
}